export default "__VITE_ASSET__DDLvgf7c__"